import { computeLinearPredictiveCodingCoefficients } from './linearPredictiveCoding';
import type { IcsInfo, ScalefactorBandsAndGroupingInfo, TemporalNoiseShaping } from './types';


export function applyTemporalNoiseShaping(
  coeffs: Float32Array,
  tns: TemporalNoiseShaping,
  ics_info: IcsInfo,
  scalefactorBandsAndGroupingInfo: ScalefactorBandsAndGroupingInfo,
  decode: boolean,
  tmp: Float32Array,
  lpc: Float32Array,
) {
  const mmm = Math.min(scalefactorBandsAndGroupingInfo.tns_max_bands, ics_info.max_sfb);
  if (mmm === 0) {
    return;
  }

  for (let w = 0; w < scalefactorBandsAndGroupingInfo.num_windows; w++) {
    let bottom = scalefactorBandsAndGroupingInfo.num_swb;
    for (let filt = 0; filt < tns.n_filt[w]; filt++) {
      const top = bottom;
      bottom = Math.max(0, top - tns.length[w][filt]);
      const order = tns.order[w][filt];
      if (order == 0) {
        continue;
      }

      computeLinearPredictiveCodingCoefficients(tns.coef[w][filt], order, 0, false, false, lpc);

      let start = scalefactorBandsAndGroupingInfo.swb_offset[Math.min(bottom, mmm)];
      const end = scalefactorBandsAndGroupingInfo.swb_offset[Math.min(top, mmm)];
      const size = end - start;
      if (size <= 0) {
        continue;
      }
      let inc: number;
      if (tns.direction[w][filt]) {
        inc = -1;
        start = end - 1;
      } else {
        inc = 1;
      }
      start += w * 128;

      if (decode) {
        for (let m = 0; m < size; m++, start += inc) {
          for (let i = 1; i <= Math.min(m, order); i++) {
            coeffs[start] -= (coeffs[start - i * inc] * lpc[i - 1]);
          }
        }
      } else {
        for (let m = 0; m < size; m++, start += inc) {
          tmp[0] = coeffs[start];
          for (let i = 1; i <= Math.min(m, order); i++) {
            coeffs[start] += (tmp[i] * lpc[i - 1]);
          }
          for (let i = order; i > 0; i--) {
            tmp[i] = tmp[i - 1];
          }
        }
      }
    }
  }
}
